import script from "./OutgoingFaxEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./OutgoingFaxEditor.vue?vue&type=script&setup=true&lang=js"

import "./OutgoingFaxEditor.vue?vue&type=style&index=0&id=437f2bea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437f2bea"]])

export default __exports__